import React from 'react';
import { Avatar } from 'modules/ui';
import { Colors } from 'modules/theme';
import { IconButton } from 'modules/ui/components/IconButton';
import styles from './AccountAvatarMenu.module.scss';
import AccountDropdown from './AccountDropdown';
import { useAnchorEl } from '../hooks';

export default function AccountAvatarMenu({
  fullName,
  city,
  state,
  country,
  avatar = null,
  onProfile,
  onEditProfile,
  onSettings,
  onLogout,
  isActive,
}) {
  const [anchorEl, handleDropdownClick, handleClose] = useAnchorEl();

  function performProfileClick(event) {
    onProfile();
    handleClose(event);
  }

  function performEditProfile(event) {
    onEditProfile();
    handleClose(event);
  }

  function performSettings(event) {
    onSettings();
    handleClose(event);
  }

  function performLogoutClick(event) {
    onLogout();
    handleClose(event);
  }

  return (
    <div className={styles.avatarMenu} onClick={handleDropdownClick}>
      <Avatar
        photoUrl={avatar}
        aria-haspopup="true"
        isActive={isActive}
        aria-label="Profile menu"
        alt="Profile menu"
      />
      <IconButton
        iconName="settingsDropdown"
        iconColor={Colors.grayishBlue}
        iconSize={12}
        onClick={handleDropdownClick}
        aria-label="Profile menu"
        aria-haspopup="menu"
        aria-expanded={Boolean(anchorEl)}
        size="large"
      />
      <AccountDropdown
        fullName={fullName}
        city={city}
        state={state}
        country={country}
        anchorEl={anchorEl}
        onProfile={performProfileClick}
        onEditProfile={performEditProfile}
        onSettings={performSettings}
        onLogout={performLogoutClick}
        onClose={handleClose}
      />
    </div>
  );
}
